module.exports = __webpack_public_path__ + "static/react-themes-material-kit-ec441f8b6b09b07fdf11bb6fd244623f.jpg";